<template>
  <div class="conversation" id="conversation">
    <div
      v-if="isLoadingConversationVisible"
      class="message__system animate__animated animate__fadeInUp animate__faster"
    >
      <div class="typing">
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
      </div>
    </div>
    <div
      v-for="message in conversation"
      :key="message.id"
      :class="{'flex justify-end': message.role === AI_ROLE_USER}"
    >
      <SystemMessage
        v-if="message.role === AI_ROLE_SYSTEM"
        :messageContent="message.content"
      />
      <AIPromptSuggestion
        v-if="isAIPromptSuggestionVisible"
        :promptSuggestions="promptSuggestions"
        @clickOnSuggestion="clickOnSuggestion"
      />
      <div v-if="message.role === AI_ROLE_USER" class="message__user-wrapper">
        <AIRetryButton v-if="systemError" @clickOnAIRetryButton="clickOnAIRetryButton" />
        <UserMessage :message="message" />
      </div>
    </div>
  </div>
</template>

<script>
import OpenAiConstants from '@/constant/openAI'

import AIPromptSuggestion from '@/components-v2/presentation-editor/side-right/right-nav/AIPromptSuggestion.vue'
import SystemMessage from '@/components-v2/presentation-editor/side-right/right-nav/SystemMessage.vue'
import UserMessage from '@/components-v2/presentation-editor/side-right/right-nav/UserMessage.vue'
import AIRetryButton from '@/components-v2/presentation-editor/side-right/right-nav/AIRetryButton.vue'

export default {
  components: {
    AIPromptSuggestion,
    SystemMessage,
    UserMessage,
    AIRetryButton,
  },
  props: {
    conversation: {
      type: Array,
      default: () => [],
    },
    promptSuggestions: {
      type: Array,
      default: () => [],
    },
    systemError: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      AI_ROLE_SYSTEM: OpenAiConstants.AI_ROLE_SYSTEM,
      AI_ROLE_USER: OpenAiConstants.AI_ROLE_USER,
    }
  },
  computed: {
    isLoadingConversationVisible() {
      return !this.isConversationVisible && (!this.aiResponse || !this.aiResponse.length)
    },
    isAIPromptSuggestionVisible() {
      return this.conversation && this.conversation.length === 1
    },
  },
  methods: {
    clickOnSuggestion(suggestion) {
      this.$emit('clickOnSuggestion', suggestion)
    },
    clickOnAIRetryButton(mode) {
      this.$emit('clickOnAIRetryButton', mode)
    },
  },
}
</script>

<style lang="scss" scoped>
.conversation {
  @apply flex-1 pt-4;
}
.message__user-wrapper {
  @apply flex items-center;
}
</style>
